import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotationsComponent } from './quotations.component';
import { CartOrderModule } from '../../_components/cart-order/cart-order.module';
import { CtSearchFiltersModule } from "@ctsolution/ct-framework";
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
  declarations: [QuotationsComponent],
  imports: [CommonModule, CartOrderModule, CtSearchFiltersModule, MatButtonModule]
})
export class QuotationsModule {}
